// Copyright (c) Quang Phan. All rights reserved. Licensed under the MIT license.

import { inlineSvg } from './preprocessor';

export * from './preprocessor';
export * from './sources.generated';

export default inlineSvg;
